import { useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import ComponentCard from '../../layouts/containers/ComponentCard';
import ModalEditar from '../../layouts/modals/ModalEditar';

const Facturacion = ({ datosFacturacion, update, setUpdate, codigo }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <>
      {modalOpen && (
        <ModalEditar
          isOpen={modalOpen}
          toggle={toggleModal}
          initialData={datosFacturacion}
          empresaId={datosFacturacion.empresaId}
          update={update}
          setUpdate={setUpdate}
          tipoEdicion="facturacion"
        />
      )}
      <ComponentCard title="Facturación">
        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Número Factura:</b>
          </Col>
          <Col md="6" className="text-truncate">
            {codigo}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Fecha Factura: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.fechaFactura}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Fecha Cobro: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.fechaCobro}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Número matrícula: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.numMat}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Estado factura: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.estado}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>% Retención IRPF: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.retencion}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Forma de pago: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.formaPago}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md="6" className="text-truncate">
            <b>Base imponible: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.base}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md="6" className="text-truncate">
            <b>Total: </b>
          </Col>
          <Col md="6" className="text-truncate">
            {datosFacturacion.totalFactura}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md="6">
            <Button onClick={toggleModal}>
              <Icon.Edit />
            </Button>
          </Col>
        </Row>
      </ComponentCard>
    </>
  );
};

Facturacion.propTypes = {
  datosFacturacion: PropTypes.object,
  update: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  setUpdate: PropTypes.func,
  codigo: PropTypes.string,
};

export default Facturacion;
